export default "__VITE_ASSET__75ffe78b__"